export default __webpack_public_path__ + "static/Canadas-rising-Inuit-TikTok-star-861734768af167766c013268fa849349.jpg";